"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowDimensions = void 0;
var react_1 = require("react");
var debounce = function (func, ms) {
    var timer;
    return function (event) {
        if (timer)
            clearTimeout(timer);
        timer = setTimeout(func, ms, event);
    };
};
/**
 * Hook to recalculate window dimensions on resize, debounced by 100ms
 * https://stackoverflow.com/a/59185109
 */
function useWindowDimensions() {
    var hasWindow = typeof window !== 'undefined';
    var getWindowDimensions = (0, react_1.useCallback)(function () {
        var width = hasWindow ? window.innerWidth : null;
        var height = hasWindow ? window.innerHeight : null;
        return {
            width: width,
            height: height,
        };
    }, [hasWindow]);
    var _a = __read((0, react_1.useState)(getWindowDimensions()), 2), windowDimensions = _a[0], setWindowDimensions = _a[1];
    (0, react_1.useEffect)(function () {
        if (hasWindow) {
            var handleResize_1 = function () {
                setWindowDimensions(getWindowDimensions());
            };
            window.addEventListener('resize', debounce(handleResize_1, 100));
            return function () { return window.removeEventListener('resize', handleResize_1); };
        }
    }, [hasWindow, getWindowDimensions]);
    return windowDimensions;
}
exports.useWindowDimensions = useWindowDimensions;
